import React from "react";

const FixedSocialNetworks: React.FC = (): JSX.Element => {
  return (
    <svg viewBox="0 0 83.89 205.373" width={60.89} height={250.373} className="fixed bottom-[100px]">
      <defs>
        <style>
          {
            ".a-s-n{fill:none;}.b-s-n{fill:#001f5f;}.c-s-n{clip-path:url(#a);}.d-s-n{clip-path:url(#b);}.e-s-n{opacity:0.25;mix-blend-mode:multiply;isolation:isolate;}.f-s-n{clip-path:url(#c);}.g-s-n{fill:#e40032;}.h-s-n{fill:#fff;}#linkedin:hover .h-s-n, #instagram:hover .h-s-n, #facebook:hover {fill:#001F5F}"
          }
        </style>
        <clipPath id="a-s-n">
          <rect
            className="a-s-n"
            width={83.89}
            height={205.373}
            transform="translate(13.076)"
          />
        </clipPath>
        <clipPath id="b-s-n">
          <rect
            className="b-s-n"
            width={83.89}
            height={205.373}
            transform="translate(13.076)"
          />
        </clipPath>
        <clipPath id="c-s-n">
          <rect className="a-s-n" width={96.966} height={205.373} />
        </clipPath>
      </defs>
      <g className="c-s-n" transform="translate(-13.076)">
        <g className="d-s-n">
          <g className="e-s-n">
            <g className="f-s-n">
              <g className="f-s-n">
                <image
                  width={96.136}
                  height={204.183}
                  xlinkHref="/images/sombra.png"
                />
              </g>
            </g>
          </g>
          <path
            className="g-s-n"
            d="M13.05,192.089V10.116H58.027A28.482,28.482,0,0,1,86.549,38.558v126a27.571,27.571,0,0,1-27.61,27.533Z"
            transform="translate(-1.385 -1.099)"
          />
          <g transform="translate(29.617 81.066)" id="instagram">
            <path
              className="h-s-n"
              d="M49.927,93.961c4.484,0,5.015.017,6.785.1a9.315,9.315,0,0,1,3.119.576,5.555,5.555,0,0,1,3.187,3.179,9.213,9.213,0,0,1,.578,3.109c.081,1.766.1,2.3.1,6.767s-.017,5-.1,6.766a9.215,9.215,0,0,1-.578,3.11,5.551,5.551,0,0,1-3.187,3.178,9.333,9.333,0,0,1-3.119.577c-1.77.08-2.3.1-6.785.1s-5.015-.017-6.785-.1a9.333,9.333,0,0,1-3.119-.577,5.551,5.551,0,0,1-3.187-3.178,9.215,9.215,0,0,1-.578-3.11c-.081-1.766-.1-2.3-.1-6.766s.017-5,.1-6.767a9.213,9.213,0,0,1,.578-3.109,5.555,5.555,0,0,1,3.187-3.179,9.315,9.315,0,0,1,3.119-.576c1.771-.081,2.3-.1,6.785-.1m0-3.017c-4.56,0-5.133.02-6.924.1a12.361,12.361,0,0,0-4.076.778,8.569,8.569,0,0,0-4.911,4.9,12.26,12.26,0,0,0-.781,4.065c-.081,1.786-.1,2.357-.1,6.9s.02,5.118.1,6.9a12.266,12.266,0,0,0,.781,4.066,8.571,8.571,0,0,0,4.911,4.9,12.339,12.339,0,0,0,4.076.778c1.791.082,2.363.1,6.924.1s5.133-.019,6.924-.1a12.339,12.339,0,0,0,4.076-.778,8.571,8.571,0,0,0,4.911-4.9,12.266,12.266,0,0,0,.781-4.066c.081-1.785.1-2.356.1-6.9s-.02-5.118-.1-6.9a12.26,12.26,0,0,0-.781-4.065,8.569,8.569,0,0,0-4.911-4.9,12.361,12.361,0,0,0-4.076-.778c-1.791-.081-2.363-.1-6.924-.1"
              transform="translate(-33.134 -90.944)"
            />
            <path
              className="h-s-n"
              d="M50.9,100.084a8.6,8.6,0,1,0,8.623,8.6,8.611,8.611,0,0,0-8.623-8.6m0,14.181a5.582,5.582,0,1,1,5.6-5.582,5.589,5.589,0,0,1-5.6,5.582"
              transform="translate(-34.104 -91.937)"
            />
            <path
              className="h-s-n"
              d="M63.725,99.458a2.015,2.015,0,1,1-2.015-2.009,2.012,2.012,0,0,1,2.015,2.009"
              transform="translate(-35.953 -91.651)"
            />
          </g>
          <path
            className="h-s-n"
            id="facebook"
            d="M55.346,173.748l.934-6.076H50.435V163.73c0-1.662.816-3.282,3.434-3.282h2.658v-5.173a32.546,32.546,0,0,0-4.718-.41c-4.814,0-7.962,2.909-7.962,8.177v4.631H38.5v6.076h5.352v14.687a21.4,21.4,0,0,0,6.587,0V173.748Z"
            transform="translate(-4.086 -16.822)"
          />
          <g transform="translate(30.686 28.069)" id="linkedin">
            <path
              className="h-s-n"
              d="M53.554,46.314c.449-.5.818-1.013,1.278-1.445a7.022,7.022,0,0,1,5.045-1.985,11.7,11.7,0,0,1,3.172.385,6.19,6.19,0,0,1,4.4,4.617,19.3,19.3,0,0,1,.586,5.29c.006,3.761-.011,7.521,0,11.281,0,.352-.1.445-.446.441q-2.914-.024-5.828,0c-.341,0-.416-.1-.415-.424q.016-5.367,0-10.735a9.653,9.653,0,0,0-.313-2.664,3,3,0,0,0-3.3-2.335c-2.3.121-3.5,1.259-3.8,3.595a13.335,13.335,0,0,0-.1,1.678c0,3.48,0,6.96.009,10.439,0,.348-.086.45-.441.447q-2.935-.025-5.871,0c-.314,0-.4-.083-.4-.4q.012-10.334,0-20.668c0-.34.112-.42.435-.417q2.786.02,5.574,0c.342,0,.43.107.423.43-.019.824-.006,1.647-.006,2.471"
              transform="translate(-35.688 -32.728)"
            />
            <path
              className="h-s-n"
              d="M41.613,54.252c0,3.409-.006,6.816.007,10.225,0,.379-.093.493-.486.489-1.941-.021-3.884-.017-5.825,0-.311,0-.4-.075-.4-.4q.015-10.352,0-20.7c0-.286.069-.388.374-.386,1.97.012,3.94.017,5.91,0,.378,0,.43.143.43.466-.011,3.436-.006,6.873-.006,10.309"
              transform="translate(-34.391 -32.792)"
            />
            <path
              className="h-s-n"
              d="M42.088,35.338a3.879,3.879,0,1,1-3.872-3.848,3.885,3.885,0,0,1,3.872,3.848"
              transform="translate(-34.33 -31.49)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default FixedSocialNetworks;
